import type { Translation } from './directus'

export enum RepresentationTypeEnum {
  curve = 'curve',
  linear = 'linear',
  bloodPressure = 'bloodPressure',
  linearWithDots = 'linearWithDots',
  curveWithDots = 'curveWithDots',
}

export const BLOOD_PRESSURE_CODE = 'blood-pressure'

export const INSULINE_CODE = 'insuline'
export const DEFAULT_COLOR = '#000000'
export interface Landmark {
  landmark_value: number
}

export interface ObservationDomain {
  startDate?: Date
  endDate?: Date
}

/**
 * An observation definition made on a patient or device.
 */
export interface ObservationDefinition {
  /**
   * Unique observation model code.
   */
  code: string
  category: string
  range_max: number
  range_min: number
  precision: number
  representation: RepresentationTypeEnum
  color: string
  landmarks: Array<Landmark>
  normalizedLandMarks?: Array<number>
  icon: string
  type: string
  unit: string
  translations: Array<Translation>
  time_series_limit: number
}
